// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__cgUUi","content":"styles_content__27n3R"};